import { render, staticRenderFns } from "./SwitchBtn.vue?vue&type=template&id=24e4638f"
import script from "./SwitchBtn.vue?vue&type=script&lang=js"
export * from "./SwitchBtn.vue?vue&type=script&lang=js"
import style0 from "./SwitchBtn.vue?vue&type=style&index=0&id=24e4638f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports